import {
    combineReducers,
} from 'redux-immutable';

import Immutable from 'immutable';
import actions from '../actions';

const INITIAL_CONFIRM_STATE = Immutable.fromJS({
    show: false,
    config: null,
});

export default combineReducers({
    standard: function(state = INITIAL_CONFIRM_STATE, action) {
        if (!action) {
            return state;
        }
        switch (action.type) {
            case actions.dialog.standard.show.type:
                return state.withMutations(state => {
                    state
                        .set('show', true)
                        .set('config', action.payload)
                    ;
                });
            case actions.dialog.standard.close.type:
                return state.withMutations(state => {
                    state
                        .set('show', false)
                    ;
                });
            case actions.dialog.standard.hidden.type:
                return state.withMutations(state => {
                    state
                        .set('config', null)
                    ;
                });
            default:
                return state;
        }
    },
});
